import PropTypes from 'prop-types'
import NotFound from '@/pages/404'
import { isPlatformFeatureOn } from './featureFlags'
import { useFeatureFlagsQuery } from './useFeatureFlags'

/**
 * Renders a route only while the named platform feature flag is on (a route's
 * `requiresPlatformFeature`). Off reads as "this page does not exist" (the
 * backend answers 404 too). While the map is still loading nothing renders,
 * so a typed URL never flashes the page; a failed request reads as off.
 *
 * Not `FeatureFlagGuard`, which checks an organisation feature.
 */
export default function PlatformFeatureGuard({ feature, children }) {
    const { data, isPending } = useFeatureFlagsQuery()
    if (isPending) return null
    if (!isPlatformFeatureOn(data, feature)) return <NotFound />
    return <>{children}</>
}

PlatformFeatureGuard.propTypes = {
    feature: PropTypes.string.isRequired,
    children: PropTypes.node
}
